export default "__VITE_ASSET__9f425353__"